<div class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1 class="m-0 text-dark">Vehicle Dashboard</h1>
              <h5 class="m-0 text-dark">Vehicle No. : {{userName}}</h5>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <!-- <li class="breadcrumb-item"><a href="#">Home</a></li> -->
                  <!-- <li class="breadcrumb-item active">Dashboard v1</li> -->
              </ol>
          </div>
          <!-- /.col -->
      </div>
      <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
      <!-- Small boxes (Stat box) -->
      <div class="row">
          
          <!-- ./col -->
          <div class="col-lg-3 col-6">
              <!-- small box -->
              <div class="small-box bg-success">
                  <div class="inner">
                      <h3>{{trainingRecordCount}}</h3>

                      <p>Total Trainings</p>
                  </div>
                  <div class="icon">
                      <i class="ion ion-stats-bars"></i>
                  </div>
                  <a [routerLink]="['/list-training']" class="small-box-footer"
                      >More info <i class="fas fa-arrow-circle-right"></i
                  ></a>
              </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
              <!-- small box -->
              <div class="small-box bg-warning">
                  <div class="inner">
                      <h3>{{testingRecordCount}}</h3>

                      <p>Total Testings</p>
                  </div>
                  <div class="icon">
                      <i class="ion ion-person-add"></i>
                  </div>
                  <a [routerLink]="['/list-testing']" class="small-box-footer"
                      >More info <i class="fas fa-arrow-circle-right"></i
                  ></a>
              </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
              <!-- small box -->
              <div class="small-box bg-danger">
                  <div class="inner">
                      <h3>{{awpRecordCount}}</h3>

                      <p>Total Awareness Programs</p>
                  </div>
                  <div class="icon">
                      <i class="ion ion-pie-graph"></i>
                  </div>
                  <a [routerLink]="['/list-awp']" class="small-box-footer"
                      >More info <i class="fas fa-arrow-circle-right"></i
                  ></a>
              </div>
          </div>
          <!-- ./col -->
      </div>
      <!-- /.row -->
  </div>
  <!-- Main row -->
</section>
<!-- /.content -->
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>
